var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2C8.05229 2 8.5 2.44772 8.5 3L8.5 5.01294H15.5L15.5 3C15.5 2.44771 15.9477 2 16.5 2C17.0523 2 17.5 2.44772 17.5 3L17.5 5.0134C19.0571 5.01796 19.8827 5.06718 20.4142 5.59873C21 6.18451 21 7.13609 21 9.03923C21 9.51502 21 9.75291 20.8536 9.89936C20.7071 10.0458 20.4714 10.0458 20 10.0458H4C3.5286 10.0458 3.29289 10.0458 3.14645 9.89936C3 9.75291 3 9.51502 3 9.03923C3 7.13609 3 6.18451 3.58579 5.59873C4.11733 5.06718 4.94285 5.01796 6.5 5.0134L6.5 3C6.5 2.44771 6.94772 2 7.5 2ZM3.58579 20.4142C3 19.8284 3 18.8856 3 17V11.9343C3 11.4629 3 11.2272 3.14645 11.0807C3.29289 10.9343 3.5286 10.9343 4 10.9343H20C20.4714 10.9343 20.7071 10.9343 20.8536 11.0807C21 11.2272 21 11.4629 21 11.9343V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H7C5.11438 21 4.17157 21 3.58579 20.4142Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDemo);
export default __webpack_public_path__ + "static/media/BookDemo.60607df9.svg";
export { ForwardRef as ReactComponent };